// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2mBMi","App_content":"App_App_content__1I7CE"};